import { UserRole } from "@/shared/types/user-role";
import type { MagicFillFormType } from "./MagicFillButton";

/**
 * Gate único de exibição/uso do Magic Fill (botão principal e varinhas por
 * campo compartilham esta regra — espelha o role gate do backend):
 * - organization_onboarding: qualquer usuário autenticado;
 * - knowledge_import: qualquer usuário autenticado (bug 83930 — usuário comum
 *   tem acesso à tela de import da KB, o Magic Fill acompanha);
 * - organization_admin / product / skill_register: apenas admin ou superadmin.
 */
export function canUseMagicFill(
  formType: MagicFillFormType,
  user: { role?: string } | null | undefined
): boolean {
  if (!user) return false;

  if (formType === "organization_onboarding" || formType === "knowledge_import") {
    return true;
  }

  const userRole: UserRole = (user.role as UserRole) || UserRole.USER;
  return userRole === UserRole.ADMIN || userRole === UserRole.SUPERADMIN;
}
